import React, { useEffect, useState } from "react";
import Preloading from "../../../components/basics/Preloading";
import { Link, useParams } from "react-router-dom";
import back from "../../../assets/images/icons/arrow-right2.svg";
import methods from "../../../services/utility";
import apiMethod from "../../../services/api-service";
import DeleteModal from "../../../components/deleteModal/DeleteModal";
import EditIcon from "../../../assets/images/icons/editIcon.svg";
import DeleteIcon from "../../../assets/images/icons/deleteIcon.svg";
import newLogo from "../../../assets/images/icons/new.png";
import copy from "../../../assets/images/icons/copy.png";

const ProductMeasurment = () => {
  const [loading, setLoading] = useState(false);
  const { restaurantId, id } = useParams();
  const [measurements, setMeasurements] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectId , setSelectId] = useState(null)
  const [gridData, setGridData] = useState([]);
  const [filterModel, setFilterModel] = useState({
    productTitle: "",
    title: "",
    restaurantId: restaurantId,
    natureType: "",
    productType: "",
    unitMeasurementId: "",
    mainMeasurementTitle: "",
    code: "",
    total: 0,
    part: 1,
    size: 4,
    parts: 0,
  });

  const [formModel, setFormModel] = useState({
    id: 0,
    measurementId: 0,
    productId: id,
    mainMeasurementId: 0,
    conversionFactor: "",
  });

  const getGridData = async () => {
    const resp = await apiMethod.getProductMeasurements(
      id,
      filterModel.title,
      filterModel.size,
      filterModel.part
    );
    if (!methods.showApiErrors(resp)) return false;
    setGridData(resp.data);
  };

  const getBaseInfo = async () => {
    const resp = await apiMethod.getRestaurantUnitMeasurements(
      filterModel.restaurantId,
      "",
      filterModel.size,
      filterModel.part
    );
    if (methods.showApiErrors(resp)) setMeasurements(resp.data);
  };

  const getProductInfo = async () => {
    const resp = await apiMethod.getProductInfo(id);
    if (!methods.showApiErrors(resp)) return false;
    filterModel.productTitle = resp.data.title;
    filterModel.natureType = resp.data.natureType;
    filterModel.productType = resp.data.productType;
    filterModel.unitMeasurementId = resp.data.unitMeasurementId;
    filterModel.mainMeasurementTitle = resp.data.mainMeasurementTitle;
    formModel.mainMeasurementId = resp.data.unitMeasurementId;
    setFilterModel({ ...filterModel });
    setFormModel({ ...formModel });
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getProductInfo();
      await getGridData();
      await getBaseInfo();
      setLoading(false);
    };
    bindData();
  }, [id]);

  const resetFilter = () => {
    filterModel.title = "";
    filterModel.restaurantId = restaurantId;
    filterModel.natureType = "";
    filterModel.productType = "";
    filterModel.unitMeasurementId = "";
    filterModel.code = "";
    filterModel.total = 0;
    filterModel.part = 1;
    filterModel.size = 4;
    filterModel.parts = 0;
    setFilterModel({ ...filterModel });
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.mainMeasurementId = filterModel.unitMeasurementId;
    formModel.measurementId = "";
    formModel.productId = id;
    formModel.conversionFactor = "";
    setFormModel({ ...formModel });
  };

  const validForm = () => {
    let errors = [];
    if (formModel.measurementId === 0) {
      errors.push(".واحد سنجش فرعی باید مقدار داشته باشد");
    }
    if (formModel.restaurantId === 0) {
      errors.push(".ششناسه شعبه باید مقدار داشته باشد");
    }
    if (formModel.conversionFactor === "") {
      errors.push(". ضریب تبدیل باید مقدار داشته باشد");
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };
  const clearSearch = async () => {
    setLoading(true);
    resetFilter();
    await getGridData();
    setLoading(false);
  };

  const createNewItem = async () => {
    if (!validForm()) return false;
    setLoading(true);
    const resp = await apiMethod.ceateProductMeasurement(formModel);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    await getGridData();
    resetForm();
    setLoading(false);
  };

  const closeDelelteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَItemToDelete = (item) => {
    resetForm()
    setSelectId(item.id)
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeProductMeasurement(formModel.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getProductMeasurementInfo(selectId);
    if (!methods.showApiErrors(resp)) return false;
    formModel.id = resp.data.id;
    formModel.productId = resp.data.productId;
    formModel.measurementId = resp.data.measurementId;
    formModel.conversionFactor = resp.data.conversionFactor;
    setFormModel({ ...formModel });
    setLoading(false);
  };

  const copyItem = (item) => {
    console.log(item)
    formModel.measurementId = item.measurementId;
    formModel.conversionFactor = item.conversionFactor;
    setFormModel({ ...formModel });
    const el = document.getElementById("add_item");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const renderMeasurment = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/baseinfo/restaurant/${restaurantId}/product`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/baseinfo/restaurant/${restaurantId}/product`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                {`کالاها / ${filterModel.productTitle} / واحد فرعی`}
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                {`کالاها / ${filterModel.productTitle} / واحد فرعی`}
                <a
                  href={`/sale/${restaurantId}/softwareGuide/#section2`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain mb-3" id="add_item">
              <div className="d-flex align-items-center gap-4 justify-content-end">
                <button className="btn-action" onClick={resetForm}>
                  <img src={newLogo} alt="Image" />
                  <span style={{ fontSize: "12px" }}>جدید</span>
                </button>
              </div>
              <div className="mb-4">
                <span className="fw-bold fs-5">
                  افزودن / ویرایش واحد فرعی کالا
                </span>
              </div>
              <div className="row g-3 mt-3">
                <div className="col-md-12 d-flex align-items-center mb-2">
                  <span className="ps-1">واحد اصلی :</span>
                  <span className="fw-bold">
                    {filterModel.mainMeasurementTitle}
                  </span>
                </div>
                <div className="col-md-6">
                  <label
                    htmlFor="measurementId"
                    className="form-label required-label"
                  >
                    واحد فرعی کالا
                  </label>
                  <select
                    id="measurementId"
                    className="form-select input-select"
                    aria-label="Default select example"
                    value={formModel.measurementId}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        measurementId: e.target.value,
                      });
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {measurements.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label
                    htmlFor="conversionFactor"
                    className="form-label required-label"
                  >
                    ضریب تبدیل
                  </label>
                  <input
                    type="text"
                    className="form-control input-form"
                    id="conversionFactor"
                    name="conversionFactor"
                    value={formModel.conversionFactor}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        conversionFactor: e.target.value,
                      });
                    }}
                    placeholder="ضریب تبدیل را بنویسید..."
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  className="btn custome-btn btn-link-purple "
                  onClick={() => {
                    resetForm();
                  }}
                >
                  انصراف
                </button>
                <button
                  onClick={() => {
                    createNewItem();
                  }}
                  type="button"
                  className="btn custome-btn btn-purple"
                >
                  ثبت وذخیره
                </button>
              </div>
            </div>
            <div className="salemain mb-3">
              <div className="row align-items-end g-3">
                <div className="col-12 col-md-3 col-lg-3">
                  <label htmlFor="funit" className="form-label">
                    عنوان
                  </label>
                  <input
                    id="searchInput"
                    className="form-control input-form"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={filterModel.title}
                    onChange={(e) => {
                      setFilterModel({
                        ...filterModel,
                        title: e.target.value,
                        part: 1,
                      });
                    }}
                    placeholder="جستجو کنید..."
                  />
                </div>
                <div className="col-12 col-lg-2">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn-wrap search-btn"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      className="btn-wrap reset-btn"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="salemain">
              <span className="d-block text-start fw-bold fs-5">
                واحد فرعی کالا
              </span>
              {/* <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-12 col-md-3 col-lg-3">
                    <label htmlFor="funit" className="form-label">
                      عنوان
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.title}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            title: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3 col-lg-3">
                    <div className="mt-4 pt-2">
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={() => {
                          searchItem();
                        }}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 col-lg-6">
                    <div className="createButton">
                      <button
                        onClick={() => {
                          openNewForm();
                        }}
                        className="btn btn-outline-purple custome-btn"
                        type="button"
                      >
                        <span className="align-middle d-inline-block">
                          واحد فرعی جدید
                        </span>{" "}
                        <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="table-responsive baseinfoTable">
                <table className="table table-md table-custom">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">ضریب تبدیل</th>
                      <th scope="col vertical-center" width="100px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <td>
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </td>
                        <td>{item.measurementTitle}</td>
                        <td>{item.conversionFactor}</td>
                        <td className="d-flex align-items-center justify-content-center gap-2">
                          <button
                            className="button-action copy-btn"
                            onClick={() => copyItem(item)}
                          >
                            <img src={copy} alt="Copy" />
                          </button>
                          <button
                            onClick={() => editItem(item.id)}
                            className="button-action"
                            type="button"
                          >
                            <img src={EditIcon} alt="Edit" />
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className="button-action"
                            type="button"
                          >
                            <img src={DeleteIcon} alt="delete" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        }
      </>
    );
  };

  return (
    <div>
      {renderMeasurment()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDelelteModal}
          deleteItem={deleteItem}
          text={"واحد فرعی"}
        />
      )}
    </div>
  );
};

export default ProductMeasurment;
